import React from "react";
import RoleManagementComponent from "../../../containers/administration/roleManagement/roleManagementComponent";

import styles from "./roleManagement.module.css";

function RoleManagement() {
  return (
    <div className={styles["content-container"]}>
      <h2 className={styles["main-text"]}>Управление ролями</h2>
      <RoleManagementComponent />
    </div>
  );
}

export default RoleManagement;
